import script from "./SubscriptionsMarketingView.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionsMarketingView.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionsMarketingView.vue?vue&type=style&index=0&id=5896ba99&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5896ba99"]])

export default __exports__